import { render, staticRenderFns } from "./ProductMappingDialog.vue?vue&type=template&id=50c68173&scoped=true"
import script from "./ProductMappingDialog.vue?vue&type=script&lang=ts"
export * from "./ProductMappingDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c68173",
  null
  
)

export default component.exports